import React from 'react';
import PropTypes from 'prop-types';
import { observer } from 'mobx-react';
import InstructionAudioForm from './InstructionAudioForm';
import InstructionAudioFormService from '../services/InstructionAudioFormService';

class InstructionAudioFormContainer extends React.Component {
  static propTypes = {
    instructionAudioId: PropTypes.string,
  };

  static defaultProps = {
    instructionAudioId: null,
  };

  instructionAudioFormService = new InstructionAudioFormService();
  componentDidMount() {
    this.instructionAudioFormService.handleLoad(this.props.instructionAudioId);
  }

  render() {
    return (
      <InstructionAudioForm
        onChange={this.instructionAudioFormService.form.setValue}
        onSubmit={this.instructionAudioFormService.handleSubmit}
        onReset={this.instructionAudioFormService.form.reset}
        onAudioDownload={this.instructionAudioFormService.handleAudioDownload}
        values={this.instructionAudioFormService.form.getValues()}
        errors={this.instructionAudioFormService.form.errors}
        loading={this.instructionAudioFormService.fetch.fetching}
        submitting={this.instructionAudioFormService.submit.fetching}
      />
    );
  }
}

export default observer(InstructionAudioFormContainer);
